"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.taskViewTableQueryStateDefaults = void 0;
const view_query_params_1 = require("../../../../common/view-query-params");
const task_view_1 = require("../../../../store/catalogs/task-view");
exports.taskViewTableQueryStateDefaults = {
    [view_query_params_1.ViewQueryStateField.Filter]: task_view_1.defaultTaskViewTableState.filter,
    [view_query_params_1.ViewQueryStateField.Search]: task_view_1.defaultTaskViewTableState.search,
    [view_query_params_1.ViewQueryStateField.Sort]: task_view_1.defaultTaskViewTableState.sort,
    [view_query_params_1.ViewQueryStateField.PageSize]: task_view_1.defaultTaskViewTableState.pageSize,
};
